App.prototype.initFormValidator = function(form, options) {
	
	var validator = $(form).validate(options);
	
	if (validator) {
		
		var zipRules = {
			'AT': {minlength: 4, maxlength: 4, digits: true},
			'BE': {minlength: 4, maxlength: 4, digits: true},
			'CH': {minlength: 4, maxlength: 4, digits: true},
			'DE': {minlength: 5, maxlength: 5, digits: true},
			'DK': {minlength: 4, maxlength: 4, digits: true},
			'ES': {minlength: 5, maxlength: 5, digits: true},
			'FR': {minlength: 5, maxlength: 5, digits: true},
			'IT': {minlength: 5, maxlength: 5, digits: true}
		};
		
    	$(form).find('.validate-zip[data-validate-zip-rel]').each(function() {
			
			var zipField = $(this);
			
			var country = $(zipField.data('validate-zip-rel'));
			
			var code = country.val();
			
			if (code in zipRules) {
				zipField.rules('add', zipRules[code]);
			}
			
			country.change(function() {
				
				zipField.rules('remove');
				
				code = $(this).val();
				
				if (code in zipRules) {
					zipField.rules('add', zipRules[code]);
				}
				
				zipField.valid();
			});
		});
	}
	
	return validator;
}

App.addModule(function(app) {

    app.on('loaded', () => {
        
        if ($.validator) {

	        $.validator.addClassRules('required-entry', {required: true});
	        $.validator.addClassRules('validate-email', {email: true});
	        $.validator.addClassRules('validate-select', {required: true});
	        $.validator.addClassRules('validate-password', {minlength: 6});
	        $.validator.addClassRules('validate-cpassword', {equalTo: '.validate-password'});
	        
	        $.validator.setDefaults({
		        submitHandler: false,
		        ignoreTitle: true,
		        errorClass: 'validation-advice',
		        highlight: function(element) {
			        $(element)
				        .addClass('validation-failed')
				        .parent()
					        .addClass('validation-error');
			        
		        },
		        unhighlight: function(element) {
			        $(element)
				        .removeClass('validation-failed')
				        .parent()
					        .removeClass('validation-error');
		        },
		        errorPlacement: function(error, element) {
			        
			        if (element.parents('.field-row').length) {
				        element.parents('.field-row').after(error);
				        return;
			        }
			        
			        if (element.parents('.form-group')) {
				        element.parents('.form-group').before(error);
				        return;
			        }
			        
			        element.after(error);
		        },
		        onfocusout: function(element, event) {
			        
			        var form = $(element).closest('form');
			        
			        if (form.data('immediate')) {
				        if (!this.checkable(element) && !this.optional(element)) {
					        this.element(element);
				        }
			        }
			        else {
				        
			        }
		        }
	        });
        }
    })

    app.on('form:submit', form => {
        
        if ($.validator && form.dataset.validate) {
            
	        const validator = app.initFormValidator(form)
	        
            form.validated = true

		    if (validator.form()) {
                form.valid = true
            } else {
			    validator.focusInvalid()
			    form.valid = false
		    }
        }
    })
})
